import OnboardCheckoutPresentation from './components/OnboardCheckoutPresentation';

export const OnboardPaymentPage = (): JSX.Element => {
  return <OnboardCheckoutPresentation />;
};
